export default __webpack_public_path__ + "static/media/layerLeft1.74545169.webp";